module.exports = __webpack_public_path__ + "img/gears-animation.49b79d69.gif";